import { useToast, ToastProps } from "vue-toast-notification";
import { useStore } from "vuex";
import { computed } from "vue";

export default function useNotification() {
  const toast = useToast();
  const duration = parseInt(process.env.TOASTR_DURATION ?? "", 10);
  const defaultOptions: ToastProps = {
    position: "top-right",
    duration: !isNaN(duration) ? duration : 5000,
    queue: true,
  };

  const escapeHtml = (value: string) => value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");

  const showMessage = (message: string, options: ToastProps = {}) => toast.default(escapeHtml(message), { ...defaultOptions, ...options });
  const showSuccess = (message: string, options: ToastProps = {}) => toast.success(escapeHtml(message), { ...defaultOptions, ...options });
  const showError = (message: string, options: ToastProps = {}) => toast.error(escapeHtml(message), { ...defaultOptions, ...options });
  const showWarning = (message: string, options: ToastProps = {}) => toast.warning(escapeHtml(message), { ...defaultOptions, ...options });
  const showInfo = (message: string, options: ToastProps = {}) => toast.info(escapeHtml(message), { ...defaultOptions, ...options });

  const store = useStore();
  const notificationCount = computed(() => store.getters["notification/getAllCount"]);
  const eSimNotificationItems = computed(() => store.getters["notification/eSimNotificationItems"]);
  const eSimNotificationCount = computed(() => store.getters["notification/eSimNotificationCount"]);
  const clearESimNotificationCount = () => store.dispatch("notification/clearESimCount");
  const simNotificationItems = computed(() => store.getters["notification/simNotificationItems"]);
  const simNotificationCount = computed(() => store.getters["notification/simNotificationCount"]);
  const clearSimNotificationCount = () => store.dispatch("notification/clearSimCount");
  const otaNotificationItems = computed(() => store.getters["notification/otaNotificationItems"]);
  const otaNotificationCount = computed(() => store.getters["notification/otaNotificationCount"]);
  const clearOTANotificationCount = () => store.dispatch("notification/clearOTACount");
  const iotsafeNotificationItems = computed(() => store.getters["notification/iotsafeNotificationItems"]);
  const iotsafeNotificationCount = computed(() => store.getters["notification/iotsafeNotificationCount"]);
  const clearIoTSAFENotificationCount = () => store.dispatch("notification/clearIoTSAFECount");
  const clearNotificationCount = () => {
    store.dispatch("notification/clearAllCount");
  };

  return {
    toast,
    showMessage,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    eSimNotificationItems,
    simNotificationItems,
    otaNotificationItems,
    iotsafeNotificationItems,
    notificationCount,
    eSimNotificationCount,
    simNotificationCount,
    otaNotificationCount,
    iotsafeNotificationCount,
    clearESimNotificationCount,
    clearSimNotificationCount,
    clearOTANotificationCount,
    clearIoTSAFENotificationCount,
    clearNotificationCount,
  };
}
